import { Routes } from '@angular/router';
import { basketLoadingGuard } from '@domgen/dgx-fe-basket';
import { CmsPageComponent, cmsPageTemplateResolver } from '@domgen/dgx-fe-cms';
import { RegistrationGaCategory } from '@us-registration/util-models';

export const REGISTRATION_FEATURE_PROTECTION_DETAILS_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      gaData: {
        category: RegistrationGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
    },
    canDeactivate: [basketLoadingGuard],
  },
];
